import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import { useTranslation } from 'react-i18next'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import styles from './confirmChangeEmailAccountDialog.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { ArrowForward, Check, Close } from '@mui/icons-material'
import { useMutation } from '@apollo/client'
import { CHANGE_EMAIL } from '@/modules/API/software/emailHandler'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ConfirmChangeEmailProps {
    open: boolean
    handleClose: () => void
    oldEmail: string
    newEmail: string
}

const ConfirmChangeEmailAccountDialog: FunctionComponent<ConfirmChangeEmailProps> = ({
    open,
    handleClose,
    oldEmail,
    newEmail
}: ConfirmChangeEmailProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deactivateEmail] = useMutation(CHANGE_EMAIL, {
        variables: {
            oldEmail: oldEmail,
            newEmail: newEmail
        },
        onCompleted: () => {
            showNotificationSuccess(t('changeEmailSuccess'))

            handleClose()
        },
        onError: () => {
            showNotificationError(t('changeEmailError'))
            handleClose()
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('changeEmail')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('changeEmailMessage')}</p>
                <div className={styles.Text}>
                    <span className={styles.TextEmail}> {oldEmail} </span>
                    <ArrowForward />
                    <span className={styles.TextEmail}> {newEmail} </span>
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Check />}
                        onClick={deactivateEmail}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmChangeEmailAccountDialog
